import { get } from 'lodash';
import { FlowNode } from '../flowState';
import { ServicesMap } from 'app/service/types';

/**
 * TODO(neilff):
 * We should refactor this function and other functions similar to it. We
 * should instead expect this function to receive a single service and all
 * of its details rather than the list of all services and their details.
 */
const getServiceAssociatedWithNode = (
  node: FlowNode | void,
  services: ServicesMap
) => {
  if (!node || !services || !node.selected_api) {
    return null;
  }

  return get(services, node.selected_api, null);
};

export default getServiceAssociatedWithNode;
